module.exports = __webpack_public_path__ + "static/media/jc_fwms.f162c8d8.png";